import useReportScrolledIntoView from "hooks/useReportScrolledIntoView"
import { useRef } from "react"
import { Row } from "./Layout"

export default function PromoCard({ promoCard, imageUrl, title, tab = null }) {
  const promoCardRef = useRef()
  useReportScrolledIntoView(promoCardRef, "discover", "promo card shown", {
    promoCard
  })

  function handleClick() {
    
  }

  return (
    <Row ref={promoCardRef} padding='0 1.5rem' onClick={handleClick}>
      <img src={imageUrl} alt={title} width={"100%"} />
    </Row>
  )
}
